import React, { useEffect, useRef, useState } from "react";
import moment from 'moment';
import styled from 'styled-components';
import { Modal } from 'bootstrap/dist/js/bootstrap';
import Highlight from 'react-highlight';
import '/node_modules/highlight.js/styles/dark.css';

const ModalStyled = styled.div`
	background: rgba(0, 0, 0, 0.4);

	&.modal {
		.modal-header h5 {
			font-size: 15px !important;
			line-height: 15px !important;
		}

		.split-pane {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 1rem;

			.pane-label {
				font-size: 11px;
				font-weight: 600;
				text-transform: uppercase;
				margin-bottom: 4px;
				color: var(--bs-gray-600);
			}

			pre {
				margin: 0;
				height: 350px;
				overflow: auto;
				border-radius: 4px;

				code {
					font-size: 11px;
					height: 100%;
				}
			}
		}

		.nav-bar {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 1rem;
			font-size: 12px;
		}
	}
`;

const DeliveryNotesBCLogsModal = React.memo((props) => {
	const modalRef = useRef(null);
	const { logs, documentNumber, closeCallback } = props;
	const [currentIndex, setCurrentIndex] = useState(0);

	useEffect(() => {
		const modal = new Modal(modalRef.current, { backdrop: false });

		const hiddenEvent = () => {
			modal._element.removeEventListener('hidden.bs.modal', hiddenEvent);
			modal.dispose();
			closeCallback();
			document.body.style.overflow = 'auto';
			document.body.style.paddingRight = '0';
		};

		modal._element.addEventListener('hidden.bs.modal', hiddenEvent);
		modal.show();

		document.body.style.overflow = 'auto';
		document.body.style.paddingRight = '0';
	}, [closeCallback]);

	const closeModal = () => {
		Modal.getInstance(modalRef.current).hide();
		closeCallback();
	};

	const currentLog = logs[currentIndex];

	return (
		<ModalStyled className="modal" tabIndex="-1" ref={modalRef}>
			<div className="modal-dialog modal-xl modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Logs envío BC – {documentNumber}</h5>
						<button type="button" className="btn-close" onClick={closeModal}></button>
					</div>
					<div className="modal-body">
						{currentLog && (
							<>
								<div className="d-flex gap-4 mb-3" style={{ fontSize: 12 }}>
									<div>
										<span className="text-muted">Fecha de envío:</span>
										&nbsp;
										<span className="fw-bold">
											{currentLog.sendDate ? moment(currentLog.sendDate).format('DD/MM/YYYY HH:mm:ss') : '-'}
										</span>
									</div>
									<div>
										<span className="text-muted">Resultado:</span>
										&nbsp;
										{currentLog.success
											? <span className="badge bg-success">OK</span>
											: <span className="badge bg-danger">ERROR</span>
										}
									</div>
								</div>
								<div className="split-pane">
									<div>
										<div className="pane-label">Request</div>
										<Highlight className="language-json">
											{JSON.stringify(currentLog.request, null, 2)}
										</Highlight>
									</div>
									<div>
										<div className="pane-label">Response</div>
										<Highlight className="language-json">
											{JSON.stringify(currentLog.response, null, 2)}
										</Highlight>
									</div>
								</div>
							</>
						)}
						{logs.length > 1 && (
							<div className="nav-bar mt-3">
								<button
									className="btn btn-sm btn-plenoil btn-plenoil-outline-blue px-2 py-0"
									style={{ minHeight: 28 }}
									disabled={currentIndex === 0}
									onClick={() => setCurrentIndex(i => i - 1)}
								>
									<i className="bi bi-chevron-left"></i>
								</button>
								<span>Envío {currentIndex + 1} / {logs.length}</span>
								<button
									className="btn btn-sm btn-plenoil btn-plenoil-outline-blue px-2 py-0"
									style={{ minHeight: 28 }}
									disabled={currentIndex === logs.length - 1}
									onClick={() => setCurrentIndex(i => i + 1)}
								>
									<i className="bi bi-chevron-right"></i>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</ModalStyled>
	);
}, () => true);

export default DeliveryNotesBCLogsModal;
